module.exports = __webpack_public_path__ + "static/media/248-300.ca0ead86.webp";